// extracted by mini-css-extract-plugin
module.exports = {"pointsDisplay":"PointsDisplay_pointsDisplay__HW8k9","points":"PointsDisplay_points__qwaMn","currency":"PointsDisplay_currency__Z3H2z"};